import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var receiveHubMessage = createAction("".concat(actionKey, ".RECEIVE_MESSAGE"), function (channel, data) { return ({
    channel: channel,
    data: data,
}); });
//# sourceMappingURL=actions.js.map